import * as React from "react";
const IcoContact = () => (
  <svg
    width={"100%"}
    height={"100%"}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M15.2268 7.61946C15.113 3.5899 12.0384 0.270614 8.12394 0.0166584C5.99111 -0.121562 3.96145 0.603931 2.40993 2.06021C0.878264 3.49532 0 5.52234 0 7.61946V11.0479C0 11.6788 0.51188 12.1907 1.1428 12.1907H1.90467C2.53559 12.1907 3.04747 11.6788 3.04747 11.0479V8.76226C3.04747 8.13134 2.53559 7.61946 1.90467 7.61946C1.90467 6.02232 2.54617 4.54157 3.71212 3.44969C4.87608 2.35847 6.39651 1.81154 8.00093 1.91868C10.9175 2.1065 13.2117 4.59183 13.3221 7.62078C12.6958 7.62607 12.1899 8.13465 12.1899 8.76226V11.0479C12.1899 11.6788 12.7018 12.1907 13.3327 12.1907C13.3327 12.8209 12.8201 13.3335 12.1899 13.3335H8.61664C8.34946 13.0993 8.00291 12.9525 7.61867 12.9525C6.77678 12.9525 6.09494 13.6344 6.09494 14.4763C6.09494 15.3182 6.77678 16 7.61867 16C8.18081 16 8.6669 15.6912 8.93144 15.2381H12.1899C13.8703 15.2381 15.2373 13.8711 15.2373 12.1907V7.61946H15.2268Z"
      fill="currentColor"
    />
  </svg>
);
export default IcoContact;
